import {
    MJPromotion
} from "../main/promotion3.js";
class Core {
    constructor() {
        this.currentTimeout = null;
    }
    promotion(object) {
        new MJPromotion(object);
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        }
        return new Promise((resolve) => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    }
}
window.addEventListener("load", function () {
    const dndPromotion = new Core().promotion;
    const core = new Core();
 
    // Create config object that can be updated dynamically
    const promotionConfig = {
        timeWait: 1000 // Default value, will be updated dynamically
    };

   // Handle click event: remove animate__pulse and add xoayvong
    // $(document).on("click", ".action__open", function() {
   
    // });
 
    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: promotionConfig,
        animResult: function (listPrize) {
            const prizeIndex = listPrize[0].indexImg;
            
        //    promotionConfig.timeWait = calculateAnimationTime(prizeIndex);  
        // After 3 seconds (after showing popup), add animate__pulse and remove xoayvong
        setTimeout(function() {
            $(".button__main .button__lixi").addClass("animate__pulse");
            $("#action").removeClass("xoayvong");
        }, 2000);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") {
                prodTemplate.fnPromotion();
            }
        },
    });
});